import React from "react";
import { Container, Row } from "reactstrap";

const Footer = () => {
  return (
    <footer className="site-footer">
      <Container>
        <Row className="py-5">
          <a role="button" style={{ color: "gray" }} href="#top">
            To the top!
          </a>
        </Row>
      </Container>
    </footer>
  );
};

export default Footer;
